import { render, staticRenderFns } from "./GadgetHistory.vue?vue&type=template&id=21df5b76&scoped=true&"
import script from "./GadgetHistory.vue?vue&type=script&lang=js&"
export * from "./GadgetHistory.vue?vue&type=script&lang=js&"
import style0 from "./GadgetHistory.vue?vue&type=style&index=0&id=21df5b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21df5b76",
  null
  
)

export default component.exports